import { type InteractionBatchedTab } from './productInteractionBatched';
import { analytics } from './segment';
import { type Action } from './types/Action';
import { type Location } from './types/Location';

type PairingInteractionBatchedParams = {
  pairingIds: number[];
  pairingNames: string[];
  pairingPositions: number[];
  actionType: Action;
  /** `'search'` today; `'home'` for the Exp 242 home feed. */
  tab?: InteractionBatchedTab;
  /** Links the batch to the active tab session (Exp 242). */
  tabSessionId?: string;
  location?: Location;
  searchId?: string;
  orderId?: number;
  pageName?: string;
  outOfStockPairingIds?: number[];
  comingSoonPairingIds?: number[];
};

export type PairingInteractionBatchedEvent = {
  pairing_ids: number[];
  pairing_names: string[];
  pairing_positions: number[];
  action_type: Action;
  tab?: InteractionBatchedTab;
  tab_session_id?: string;
  location?: Location;
  search_id?: string;
  order_id?: number;
  page_name?: string;
  client: 'web';
  out_of_stock_pairing_ids?: number[];
  coming_soon_pairing_ids?: number[];
};

export const pairingInteractionBatched = ({
  pairingIds,
  pairingNames,
  pairingPositions,
  actionType,
  tab,
  tabSessionId,
  location,
  searchId,
  orderId,
  pageName,
  outOfStockPairingIds,
  comingSoonPairingIds,
}: PairingInteractionBatchedParams) => {
  const event: PairingInteractionBatchedEvent = {
    pairing_ids: pairingIds,
    pairing_names: pairingNames,
    pairing_positions: pairingPositions,
    action_type: actionType,
    tab,
    tab_session_id: tabSessionId,
    location,
    search_id: searchId,
    order_id: orderId,
    page_name: pageName,
    client: 'web',
    ...(outOfStockPairingIds !== undefined && {
      out_of_stock_pairing_ids: outOfStockPairingIds,
    }),
    ...(comingSoonPairingIds !== undefined && {
      coming_soon_pairing_ids: comingSoonPairingIds,
    }),
  };
  analytics.track('Pairing Interaction Batched', event);
};
